import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { BaseFormViewComponentProps, FormHandles } from "models/propTypes/genericFormProps";
import { FormEnums } from "models/enums";
import { AnnualAccountFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { GenericForm } from "components/common";
//#endregion

const AnnualAccountRejectForm: ForwardRefRenderFunction<FormHandles, BaseFormViewComponentProps> = (props, ref) => {
  return (
    <GenericForm<AnnualAccountFormTypes.Reject>
      formRef={ref}
      {...props}
      fields={{
        message: {
          label: TranslationKeys.Common.Message,
          type: FormEnums.FormFieldType.TEXTAREA,
        },
      }}
    />
  );
};

export default forwardRef(AnnualAccountRejectForm);
